import Block from "@components/block"
import floorImg from "@imagesgz/content/floor.jpeg"
import introAppImg from "@imagesgz/content/intro-app.png"
import introPcImg from "@imagesgz/content/intro-pc.png"
import Box, { BoxTitle } from "@src/components/box"
import Clickable from "@src/components/clickable"
import EventDate from "@src/components/eventDate"
import Media from "@src/components/media"
import ResponsiveImage from "@src/components/responsiveContent/image"
import buy1Img from "@imagesgz/content/buy1.png"
import buy2Img from "@imagesgz/content/buy2.png"
import classnames from "@src/utils/classnames"
import React from "react"
import * as styles from "./intro.module.scss"
import config from "@config"

const Intro = () => {
  return (
    <Block className={styles.intro} id="intro">
      <Box>
        <BoxTitle
          sub="G-Fusion Tour 2021"
          desc={
            <>
              <p>
                核聚变 Tour
                的主旨一直是希望可以营造一个让所有玩家一起欢聚、轻松、愉快的氛围，从5月份的「弧光行动」开始，我们就想将现场的整体氛围和主题结合的更紧密，让玩家们沉浸其中。所以我们将今年的核聚变Tour
                与吉考斯工业发布的「机组成员」小人形象结合，打造成了一个「机组成员」的大型游乐园。
              </p>

              <p>
                这次的核聚变广州站是个“水上”游乐园哦，让我们在广州一起感受一下夏天最后的小尾巴吧～（对不起，现场并没有水，但绝对非常好玩）
              </p>

              <p>那么话不多说，让我们来看看这个游乐场里都能玩到点什么。</p>
            </>
          }
        >
          核聚变2021 Tour 广州站
        </BoxTitle>
        <div className={classnames("mb", styles.introImage)}>
          <ResponsiveImage pc={introPcImg} mobile={introAppImg} />
        </div>
        <EventDate
          day1="11.20"
          date1="9:00-17:00"
          day2="11.21"
          date2="9:00-17:00"
          loc1="广州保利世贸博览馆3、4号馆"
          price1Img={buy1Img}
          price2Img={buy2Img}
          link={config.linksGz.buy}
        />
        <Media caption="核聚变回顾">
          <div className={styles.video}>
            <div>
              <iframe
                title="核聚变回顾"
                allowFullScreen
                frameBorder="0"
                framespacing="0"
                src="https://www.taptap.com/video/1914707/embed?thumb=https%3A%2F%2Fimg2.tapimg.com%2Fbbcode%2Fimages%2F874cbe9e378720ecf15be8725bea7ef3.jpg"
              />
            </div>
          </div>
        </Media>
        <Media caption="核聚变2021 Tour 广州站 场地图">
          <Clickable appNavTo={floorImg}>
            <ResponsiveImage pc={floorImg} />
          </Clickable>
        </Media>
      </Box>
    </Block>
  )
}

export default Intro
